const fromOptions = (options) => ({
  ...options,
  startDate: Array.isArray(options.startDate) ? options.startDate.join('-') : options.startDate,
});

export default fromOptions;
